import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  row: { alignItems: 'center', flexDirection: 'row' },
});

export default styles;
